// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tc-table-status[data-v-1df1a7b8]{display:flex;justify-content:center;align-items:center;text-align:center;font-size:.75rem;color:#9e9e9e;border-top:1px solid #eee;padding:8px 0;margin-bottom:1em}.tc-table-status>.message[data-v-1df1a7b8]{margin-top:-8px}.status-message[data-v-1df1a7b8]{width:100%}.message-body[data-v-1df1a7b8]{border:none}", ""]);
// Exports
module.exports = exports;
